/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const BoltCloudSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="m5.002 19.996.002.002c0 .001 0 .002.002.002H18.437A5.563 5.563 0 0 0 21.14 9.574a.266.266 0 0 1-.135-.213 4.317 4.317 0 0 0-5.215-3.903.264.264 0 0 1-.25-.077 7.346 7.346 0 0 0-12.702 4.628.264.264 0 0 1-.135.217 5.208 5.208 0 0 0 2.299 9.77Zm5.943-11.438a.418.418 0 0 0-.4.306L9.31 13.19a.424.424 0 0 0 .4.544h.99l-.145 2.37c-.026.428.513.623.755.273l2.906-4.19c.195-.282-.002-.671-.34-.671h-.79l1.012-2.363a.425.425 0 0 0-.381-.595h-2.772Z" /></svg>);
const BoltCloudSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={BoltCloudSolidBase} {...rest} ref={ref} />);
export default BoltCloudSolid;